import React, { useRef, useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMoreRounded";
import { DPButton } from "Components/DP";
import useStyles from "./styles";
import Popover from "@material-ui/core/Popover";
import { UserFiltersMenu } from "./UserFiltersMenu/UserFiltersMenu";
import { useUserFilters, UserFilters as UserFiltersType  } from "Hooks/useUserFilters";

export const UserFilters = () => {
  const { applyFilters, resetFilters } = useUserFilters();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const filtersButton = useRef(null);
  const classes = useStyles();

  const toggleFilters = () => {
    setFiltersOpen(!filtersOpen);
  };

  const closeFilters = () => {
    setFiltersOpen(false);
  };

  return (
    <>
      <DPButton
        className={classes.button}
        id="user-adv-filters"
        onClick={toggleFilters}
        variant="text"
      >
        <span id="adv-filters" ref={filtersButton} />
        Filters
        <ExpandMoreIcon className={classes.buttonIcon} />
      </DPButton>
      <Popover
        classes={{ paper: classes.popover }}
        open={filtersOpen}
        anchorEl={filtersButton.current}
        anchorOrigin={{ horizontal: 50, vertical: 20 }}
        onClose={closeFilters}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <UserFiltersMenu
          onApply={(newFilters: UserFiltersType) => {
            applyFilters(newFilters);
            closeFilters();
          }}
          onClear={() => {
            resetFilters();
            closeFilters();
          }}
        />
      </Popover>
    </>
  );
};
